module.exports = __webpack_public_path__ + "static/media/iconCardsActive.2f25d0fa.svg";